export default __webpack_public_path__ + "static/media/shonit 7parts.png.95f609ad.png";